import DashboardIcons from '@/icons/DashboardIcons'
import ListIcons from '@/icons/ListIcons'
import { useTranslation } from 'react-i18next'
import AttendanceSyncLogList from '../AttendanceSyncLogs'
import Dashboard from './Dashboard'
import WorkDayList from './List'
import LoadIcons from '@/icons/LoadIcons'

export const tabs = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTranslation()

    return [
        {
            label: t('dashboard'),
            value: 'dashboard',
            startIcon: <DashboardIcons />,
            component: <Dashboard />,
        },
        {
            label: t('workday-list'),
            value: 'list',
            startIcon: <ListIcons />,
            component: <WorkDayList />,
        },
        {
            label: t('attendance_sync_logs_title'),
            value: 'sync-logs',
            startIcon: <LoadIcons />,
            component: <AttendanceSyncLogList />,
        },
    ]
}
